// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* prevent 'bounce' in scrolling */
html {
    height: 100%;
    width: 100%;
    overflow: hidden;
}

body {
    height: 100%;
    width: 100%;
    overflow: auto;
    color: #888888;
    background-color: #060606;
}

.hidden {
    display: none;
}

.modal-content {
    background-color: #202020;
}

.btn-default {
  color: #ffffff;
  background-color: #424242;
  border-color: #424242;
}

 
.thumbnails {
    margin:0px;
    margin-bottom: 0px;
    overflow-y:scroll;
    overflow-x:hidden;
}


/* Assistant Modification- By Abdus Samad- Freelancer.com/55samad */
#assistant{
    position: fixed;
    right: -100px;
    bottom: 15%;
    z-index: 999;
}
.assistant_block{
    width: 270px;
    height: 122px;
    background: rgba(29, 28, 28, 0.66);
    border: 1px solid #5f5f5f;;
    padding: 4px;
    position: relative;
}
.assistant_block_covariables{
    width: 270px;
    height: 100%;
    background: rgba(29, 28, 28, 0.66);
    border: 1px solid #5f5f5f;
    padding: 4px;
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA,mEAAmE;AACnE;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["/* prevent 'bounce' in scrolling */\nhtml {\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n\nbody {\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    color: #888888;\n    background-color: #060606;\n}\n\n.hidden {\n    display: none;\n}\n\n.modal-content {\n    background-color: #202020;\n}\n\n.btn-default {\n  color: #ffffff;\n  background-color: #424242;\n  border-color: #424242;\n}\n\n \n.thumbnails {\n    margin:0px;\n    margin-bottom: 0px;\n    overflow-y:scroll;\n    overflow-x:hidden;\n}\n\n\n/* Assistant Modification- By Abdus Samad- Freelancer.com/55samad */\n#assistant{\n    position: fixed;\n    right: -100px;\n    bottom: 15%;\n    z-index: 999;\n}\n.assistant_block{\n    width: 270px;\n    height: 122px;\n    background: rgba(29, 28, 28, 0.66);\n    border: 1px solid #5f5f5f;;\n    padding: 4px;\n    position: relative;\n}\n.assistant_block_covariables{\n    width: 270px;\n    height: 100%;\n    background: rgba(29, 28, 28, 0.66);\n    border: 1px solid #5f5f5f;\n    padding: 4px;\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
